import { render, staticRenderFns } from "./UserCreateModal.vue?vue&type=template&id=da477e8e&scoped=true&"
import script from "./UserCreateModal.vue?vue&type=script&lang=js&"
export * from "./UserCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da477e8e",
  null
  
)

export default component.exports